import { useMemo, useRef } from "react"
import { useTextTokenLookup } from "./useTextTokenLookup"
import { resolveTokens } from "#/services/contentful/text-tokens/resolver"
import { reportErrorMessage } from "#/utils/ErrorReporting"

export function useResolveText<T extends string | null | undefined>(input: T): T {
  const { lookup, isLoading } = useTextTokenLookup()
  const reportedRef = useRef<Set<string>>(new Set())

  return useMemo(() => {
    if (input == null) return input
    if (isLoading) return input
    return resolveTokens(input, lookup, (name) => {
      if (reportedRef.current.has(name)) return
      reportedRef.current.add(name)
      reportErrorMessage(`Unknown textToken: ${name}`)
    }) as T
  }, [input, lookup, isLoading])
}
